import SwitchScene from './scenes/SwitchScene';
import PipeScene from './scenes/PipeScene';

init();

function init() {
  const scenes = {
    //SwitchScene,
    PipeScene,
  };

  const app = {
    Scene: SwitchScene,
    scenes,
  };

  app.scene = new app.Scene(app);

  // app.pipeScene = new PipeScene(app);

  return app;
}
